import { supabase } from '@/lib/supabaseClient';
import { DEFAULT_SYSTEM_CONFIG, type SystemConfig } from '@/types/systemConfig';

let cachedConfig: SystemConfig | null = null;
let fetchPromise: Promise<SystemConfig> | null = null;

const loadSystemConfig = async (): Promise<SystemConfig> => {
  const { data, error } = await supabase
    .from('system_config')
    .select('*')
    .eq('id', 1)
    .single();

  if (error || !data) {
    console.warn('[system_config] Yüklenemedi, varsayılan ayarlar kullanılıyor:', error?.message);
    cachedConfig = DEFAULT_SYSTEM_CONFIG;
  } else {
    cachedConfig = data as SystemConfig;
  }

  fetchPromise = null;
  return cachedConfig;
};

export async function fetchSystemConfig(): Promise<SystemConfig> {
  if (cachedConfig) return cachedConfig;
  if (fetchPromise) return fetchPromise;

  fetchPromise = loadSystemConfig();
  return fetchPromise;
}

export function invalidateSystemConfig() {
  cachedConfig = null;
  fetchPromise = null;
}
